import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type TerminalOptionsQueryVariables = GraphQLTypes.Exact<{
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  query?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type TerminalOptionsQueryResult = { __typename?: 'Query' } & {
  transportTerminals?: GraphQLTypes.Maybe<
    { __typename?: 'TransportTerminalConnection' } & {
      nodes?: GraphQLTypes.Maybe<
        Array<
          { __typename?: 'TransportTerminal' } & Pick<GraphQLTypes.TransportTerminal, 'id' | 'label'> & {
              unlocode: GraphQLTypes.TransportTerminal['code'];
            }
        >
      >;
    }
  >;
};

export const TerminalOptionsDocument = gql`
  query terminalOptions($after: String, $before: String, $first: Int, $last: Int, $query: String) {
    transportTerminals(after: $after, before: $before, first: $first, last: $last, query: $query) {
      nodes {
        id
        label
        unlocode: code
      }
    }
  }
`;
